import {createSelector} from 'reselect';

/* Utils */
import {generateSeoBreadCrumbConfigs} from '../../modules/seo/seoUtils';

const seoBreadcrumbArraySelector = (state) => {
  const {
    seoState: {
      seoInfo,
    },
  } = state;

  return seoInfo?.breadcrumbArray;
};

const seoBreadCrumbConfigArraySelector = createSelector(
  [seoBreadcrumbArraySelector],
  (seoBreadcrumbArray) => {
    return seoBreadcrumbArray && generateSeoBreadCrumbConfigs(seoBreadcrumbArray);
  }
);

export {
  seoBreadCrumbConfigArraySelector,
}
